import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { CircularProgress, Box, Typography } from '@mui/material';
const AdminRoute = ({ children }) => {
  const { t } = useTranslation();
  const { isAuthenticated, loading, user } = useContext(AuthContext);
  const navigate = useNavigate();
  useEffect(() => {
    if (!loading) {
      if (!isAuthenticated) {
        // Store the current location to redirect back after login
        const currentPath = window.location.pathname;
        
        // Only store the redirect path if we're not already on the login page
        if (currentPath !== '/login') {
          localStorage.setItem('redirectAfterLogin', currentPath);
        }
        
        navigate('/login');
      } else if (!user || user.is_admin < 1) {
        navigate('/dashboard');
      }
    }
  }, [isAuthenticated, loading, navigate, user]);
  // Add more detailed logging
  if (loading) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 4 }}>
        <CircularProgress sx={{ mb: 2 }} />
        <Typography variant="body2" color="text.secondary">
          {t('nav.checkingAdmin')}
        </Typography>
      </Box>
    );
  }
  if (!isAuthenticated) {
    // Store the current location to redirect back after login
    const currentPath = window.location.pathname;
    
    // Only store the redirect path if we're not already on the login page
    if (currentPath !== '/login') {
      localStorage.setItem('redirectAfterLogin', currentPath);
    }
    
    return <Navigate to="/login" />;
  }
  if (!user || user.is_admin < 1) {
    return <Navigate to="/dashboard" />;
  }
  return children;
};
export default AdminRoute;
